import { PRODUCT_VIEW_LAYER } from '../../../components/AssetTargetsDialog/helpers/assetProductLinks';

import resolveMasterUsageAltText from './resolveMasterUsageAltText';
import resolveSharedMediaAltState from './resolveSharedMediaAltState';

export const MEDIA_ALT_VIEW_MODE = {
  MASTER: 'master',
  CHANNEL_DRAFT: 'channelDraft',
  CHANNEL_PUBLISHED: 'channelPublished',
};

export const resolveMediaAltViewMode = (viewContext) => {
  if (viewContext?.layer === PRODUCT_VIEW_LAYER.MASTER) return MEDIA_ALT_VIEW_MODE.MASTER;
  if (viewContext?.layer === PRODUCT_VIEW_LAYER.LIVE) return MEDIA_ALT_VIEW_MODE.CHANNEL_PUBLISHED;
  return MEDIA_ALT_VIEW_MODE.CHANNEL_DRAFT;
};

const countSharedUsages = ({ usedByProduct, usedByVariants }) => (
  (usedByProduct ? 1 : 0) + (usedByVariants?.length || 0)
);

const normalizeAltForDiff = (value) => (
  value == null || value === '' ? '' : String(value)
);

export default function resolveMediaAltDisplayState(asset, {
  viewContext,
  productId,
  variantId,
  isVariant,
}) {
  const mode = resolveMediaAltViewMode(viewContext);

  if (mode === MEDIA_ALT_VIEW_MODE.MASTER) {
    return {
      mode,
      value: resolveMasterUsageAltText(asset, { productId, variantId, isVariant }),
      publishedValue: null,
      isEditable: true,
      hasUnpublishedChanges: false,
      isShared: false,
      pendingOwner: null,
      listingId: null,
    };
  }

  const listingId = viewContext?.listingProductId || productId;
  const sharedState = resolveSharedMediaAltState(asset, listingId);
  const isShared = countSharedUsages(sharedState) > 1;

  if (mode === MEDIA_ALT_VIEW_MODE.CHANNEL_PUBLISHED) {
    return {
      mode,
      value: sharedState.publishedAlt ?? '',
      publishedValue: sharedState.publishedAlt,
      isEditable: false,
      hasUnpublishedChanges: false,
      isShared,
      pendingOwner: sharedState.pendingOwner,
      listingId,
    };
  }

  const draftValue = sharedState.hasPending
    ? sharedState.pendingAlt
    : (sharedState.draftBaselineAlt ?? sharedState.publishedAlt ?? '');
  const hasUnpublishedChanges = sharedState.draftBaselineAlt == null
    ? sharedState.hasPending && sharedState.pendingAlt !== sharedState.publishedAlt
    : normalizeAltForDiff(draftValue) !== normalizeAltForDiff(sharedState.draftBaselineAlt);

  return {
    mode,
    value: draftValue ?? '',
    publishedValue: sharedState.publishedAlt,
    isEditable: true,
    hasUnpublishedChanges,
    isShared,
    pendingOwner: sharedState.pendingOwner,
    listingId,
  };
}
